import { render } from "./ContactsMapAzure.vue?vue&type=template&id=10790d36"
import script from "./ContactsMapAzure.vue?vue&type=script&lang=js"
export * from "./ContactsMapAzure.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__